/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driver_Order_Cod_LabelInputs */

const vi_driver_order_cod_label = /** @type {(inputs: Driver_Order_Cod_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu hộ (COD)`)
};

/**

* @param {Driver_Order_Cod_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_order_cod_label = /** @type {((inputs?: Driver_Order_Cod_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_Order_Cod_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_order_cod_label(inputs)
});